import jan from "../images/team/webentwickler_jan.webp";
import lukas from "../images/team/webdesigner_lukas.webp";
import max from "../images/team/grafikdesigner_max.webp";
import yannic from "../images/team/webentwickler_yannic.webp";

export function teamMembers() {
  return [
    ...[
      {
        Image: lukas,
        title: "Lukas",
        text: "Gründer & Entwickler",
        alt: "Der Webdesigner und Webentwickler Lukas Körber",
      },
      {
        Image: jan,
        title: "Jan",
        text: "Webentwickler",
        alt: "Der Webentwickler Jan Brechtel",
      },
      {
        Image: max,
        title: "Max",
        text: "Grafikdesigner",
        alt: "Der Grafikdesigner Max Hayen",
      },
      {
        Image: yannic,
        title: "Yannic",
        text: "Webdesigner",
        alt: "Der Webentwickler Yannic",
      } /* 
      {
        Image: jan,
        title: "Pelle",
        text: "Entwickler",
        alt: "Der Webentwickler Jan Brechtel",
      }, */,
    ],
  ];
}
